import React from 'react';

/**
 * Shake Quantity Monitor Component
 * This feature has been removed
 */
const ShakeQuantityMonitor = () => {
    return (
        <div className="bg-white rounded-xl border border-gray-200 p-8 text-center">
            <div className="mx-auto w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-3">
                <svg className="w-6 h-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-900">Feature Removed</h3>
            <p className="text-gray-500 mt-2">Shake quantity monitoring has been removed from the system.</p>
        </div>
    );
};

export default ShakeQuantityMonitor;
